export default __webpack_public_path__ + "static/media/prizes-header-mobile.a7bc6221.jpg";